/**
 * Free Shipping Progress Bar
 * Handles the display and update of free shipping progress bar
 */

(function() {
  'use strict'

  // Ensure theme object exists
  window.theme = window.theme || {}
  window.NextSkyTheme = window.NextSkyTheme || window.theme

  /**
   * Free Shipping Progress Bar Class
   */
  class FSProgressBar {
    constructor(selector) {
      this.selector = selector || 'free-ship-progress-bar'
      this.elements = document.querySelectorAll(this.selector)
      this.init()
    }

    init() {
      this.elements.forEach(element => {
        this.updateProgressBar(element)
      })
    }

    updateProgressBar(element) {
      const progressElement = element.querySelector('.progress')
      const messageElement = element.querySelector('.progress-bar-message')

      if (!progressElement) {
        console.warn('Free shipping progress: progress element not found')
        return
      }

      const totalOrder = parseInt(progressElement.getAttribute('data-total-order')) || 0
      const freeAmount = parseInt(progressElement.getAttribute('data-fe-amount')) || 10000
      const unavailableMessage = element.getAttribute('data-fe-unavailable') || ''
      const availableMessage = element.getAttribute('data-fe-available') || ''

      // Calculate progress percentage
      const progress = Math.min((totalOrder / freeAmount) * 100, 100)
      const remaining = Math.max(freeAmount - totalOrder, 0)

      // Update progress bar width
      progressElement.style.width = progress + '%'

      // Update message
      if (messageElement) {
        if (totalOrder >= freeAmount) {
          // Free shipping achieved
          messageElement.textContent = availableMessage || 'You qualify for free shipping!'
          messageElement.classList.add('free-shipping-achieved')
          messageElement.classList.remove('free-shipping-pending')
        } else {
          // Free shipping not yet achieved
          const formattedRemaining = this.formatMoney(remaining)

          // 解码 HTML 实体（如果使用了 HTML 实体编码）
          let decodedMessage = unavailableMessage
            .replace(/&#123;&#123;/g, '{{')
            .replace(/&#125;&#125;/g, '}}')
            .replace(/&amp;#123;&amp;#123;/g, '{{')
            .replace(/&amp;#125;&amp;#125;/g, '}}')

          // 支持多种占位符格式：{{ amount }}, {{amount}}, {amount}, [amount], amount
          let message = decodedMessage
            .replace(/\{\{\s*amount\s*\}\}/gi, formattedRemaining)
            .replace(/\{\s*amount\s*\}/gi, formattedRemaining)
            .replace(/\{amount\}/gi, formattedRemaining)
            .replace(/\[\s*amount\s*\]/gi, formattedRemaining)
            .replace(/\[amount\]/gi, formattedRemaining)

          // 如果消息中仍然包含未替换的占位符，尝试直接替换
          if (message === decodedMessage && decodedMessage.toLowerCase().includes('amount')) {
            // 尝试替换各种可能的格式（不区分大小写）
            const amountRegex = /amount/gi
            message = decodedMessage.replace(amountRegex, formattedRemaining)
          }

          messageElement.textContent = message
          messageElement.classList.add('free-shipping-pending')
          messageElement.classList.remove('free-shipping-achieved')
        }
      }
    }

    formatMoney(cents) {
      // Use theme's money format if available
      if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
        return window.theme.Currency.formatMoney(cents)
      }

      // Fallback formatting
      const amount = cents / 100
      return '$' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }

    update(totalOrder) {
      this.elements.forEach(element => {
        const progressElement = element.querySelector('.progress')
        if (progressElement) {
          progressElement.setAttribute('data-total-order', totalOrder)
          this.updateProgressBar(element)
        }
      })
    }
  }

  /**
   * Free Shipping Progress Bar Custom Element
   */
  class FreeShipProgressBar extends HTMLElement {
    constructor() {
      super()
      this.progressBar = null
    }

    connectedCallback() {
      this.init()
    }

    init() {
      // Initialize progress bar for this element
      if (!this.progressBar) {
        this.progressBar = new FSProgressBar()
        this.progressBar.elements = [this]
        this.progressBar.updateProgressBar(this)
      }
    }

    update(totalOrder) {
      const progressElement = this.querySelector('.progress')
      if (progressElement) {
        progressElement.setAttribute('data-total-order', totalOrder)
        if (this.progressBar) {
          this.progressBar.updateProgressBar(this)
        }
      }
    }
  }

  // Register custom element
  if (!customElements.get('free-ship-progress-bar')) {
    customElements.define('free-ship-progress-bar', FreeShipProgressBar)
  }

  // Add to theme namespace for backward compatibility
  window.theme.FSProgressBar = FSProgressBar
  window.NextSkyTheme = window.NextSkyTheme || {}
  window.NextSkyTheme.FSProgressBar = FSProgressBar

  // Auto-initialize on DOM ready
  function initializeProgressBars() {
    new FSProgressBar()

    // For product pages, sync cart total on load
    const productPageBars = document.querySelectorAll('free-ship-progress-bar[data-product-page]')
    if (productPageBars.length > 0) {
      // Initialize variant bottom text on page load
      // 延迟执行以确保 Shopify 变体选择器已初始化
      setTimeout(function() {
        initializeVariantBottomText()
      }, 100)

      // Try multiple times to sync from cart drawer (cart drawer may load asynchronously)
      // First attempt: immediate sync if cart drawer is already loaded
      syncCartDrawerToProductPage()

      // Second attempt: after a short delay
      setTimeout(function() {
        syncCartDrawerToProductPage()
        // Also fetch cart to ensure accuracy (as fallback)
        fetchCartAndUpdate()
      }, 200)

      // Third attempt: after a longer delay in case cart drawer loads later
      setTimeout(function() {
        syncCartDrawerToProductPage()
      }, 800)
    } else {
      // For non-product pages (like cart drawer), also sync on load
      setTimeout(function() {
        syncCartDrawerToProductPage()
      }, 200)
    }
  }

  // 初始化变体底部文本（页面加载时）
  function initializeVariantBottomText() {
    let variantId = null

    // 首先尝试从 URL 参数获取 variant ID
    const urlParams = new URLSearchParams(window.location.search)
    const urlVariantId = urlParams.get('variant')
    if (urlVariantId) {
      variantId = urlVariantId
    } else {
      // 如果没有 URL 参数，尝试从产品表单获取当前变体 ID
      const productForm = document.querySelector('form[action*="/cart/add"]')
      if (productForm) {
        const variantInput = productForm.querySelector('[name="id"]')
        if (variantInput && variantInput.value) {
          variantId = variantInput.value
        }
      }
    }

    if (variantId) {
      updateVariantBottomText(variantId)
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProgressBars)
  } else {
    initializeProgressBars()
  }

  // Listen for cart updates
  document.addEventListener('cart:update', function(event) {
    if (event.detail && event.detail.cartData) {
      const cartTotal = event.detail.cartData.total_price || 0
      const itemCount = event.detail.cartData.item_count || 0

      // Update all progress bars with new cart total and item count
      setTimeout(function() {
        updateAllProgressBars(cartTotal, itemCount)
      }, 100)
    }
  })

  // Listen for cart:build event (when cart is rebuilt)
  document.addEventListener('cart:build', function() {
    setTimeout(function() {
      // Sync from cart drawer first
      syncCartDrawerToProductPage()
      // Also fetch cart to ensure accuracy
      fetchCartAndUpdate()
    }, 200)
  })

  // Listen for cart:updated event
  document.addEventListener('cart:updated', function(event) {
    setTimeout(function() {
      // Try to get item count from event detail
      if (event.detail && event.detail.cart) {
        const cartTotal = event.detail.cart.total_price || 0
        const itemCount = event.detail.cart.item_count || 0
        updateAllProgressBars(cartTotal, itemCount)
      } else {
        // Fallback: fetch cart data
        fetchCartAndUpdate()
      }
    }, 200)
  })

  // Function to get current variant price from product form
  function getCurrentVariantPrice() {
    const productForm = document.querySelector('form[action*="/cart/add"]')
    if (!productForm) return 0

    const variantInput = productForm.querySelector('[name="id"]')
    if (!variantInput || !variantInput.value) return 0

    const variantId = variantInput.value

    // Try to get variant price from variant JSON data
    const variantJsonTextarea = document.querySelector('textarea[data-variant-json]')
    if (variantJsonTextarea) {
      try {
        const variants = JSON.parse(variantJsonTextarea.textContent || variantJsonTextarea.value)
        if (Array.isArray(variants)) {
          const variant = variants.find(function(v) {
            return v.id && v.id.toString() === variantId.toString()
          })
          if (variant && variant.price) {
            return parseInt(variant.price)
          }
        }
      } catch (e) {
        console.warn('Failed to parse variant JSON:', e)
      }
    }

    // Try to get from variant selector elements
    const variantSelectors = document.querySelectorAll('[data-variant-id="' + variantId + '"], [value="' + variantId + '"]')
    for (let i = 0; i < variantSelectors.length; i++) {
      const variantElement = variantSelectors[i]
      const priceAttr = variantElement.getAttribute('data-price') ||
                       variantElement.getAttribute('data-variant-price') ||
                       (variantElement.closest && variantElement.closest('[data-variant-price]') && variantElement.closest('[data-variant-price]').getAttribute('data-variant-price'))
      if (priceAttr) {
        return parseInt(priceAttr)
      }
    }

    return 0
  }

  // Function to get cart item count from DOM
  function getCartItemCount() {
    // Try to get from cart drawer
    const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('main-cart') || document.querySelector('#CartDrawer')
    if (cartDrawer) {
      // Check if cart drawer has items indicator
      const cartItems = cartDrawer.querySelectorAll('[data-cart-item], .cart-item, .cart__item')
      if (cartItems.length > 0) {
        return cartItems.length
      }
      // Check if cart drawer shows empty state
      const isEmpty = cartDrawer.classList.contains('is-empty') || cartDrawer.querySelector('.cart-empty, .cart__empty')
      if (isEmpty) {
        return 0
      }
    }

    // Try to get from cart count badge
    const cartCount = document.querySelector('[data-cart-count], .cart-count, #CartCount')
    if (cartCount) {
      const count = parseInt(cartCount.textContent || cartCount.getAttribute('data-count') || '0')
      return count
    }

    return undefined
  }

  // Function to sync cart drawer progress to product page
  function syncCartDrawerToProductPage() {
    const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('main-cart') || document.querySelector('#CartDrawer')

    if (!cartDrawer) return

    const drawerProgressBar = cartDrawer.querySelector('free-ship-progress-bar')
    if (!drawerProgressBar) {
      // If progress bar doesn't exist, cart might be empty
      const itemCount = getCartItemCount()
      if (itemCount !== undefined) {
        toggleProgressBarVisibility(itemCount)
      }
      return
    }

    const drawerProgress = drawerProgressBar.querySelector('.progress')
    if (!drawerProgress) return

    const cartTotal = parseInt(drawerProgress.getAttribute('data-total-order')) || 0
    const itemCount = getCartItemCount()

    // Update product page progress bars with cart drawer's cart total
    updateAllProgressBars(cartTotal, itemCount)
  }

  // Function to toggle progress bar visibility based on cart item count
  function toggleProgressBarVisibility(itemCount) {
    const progressBars = document.querySelectorAll('free-ship-progress-bar')
    progressBars.forEach(function(bar) {
      if (itemCount > 0) {
        // Show progress bar if cart has items
        bar.style.display = ''
        bar.removeAttribute('hidden')
      } else {
        // Hide progress bar if cart is empty
        bar.style.display = 'none'
        bar.setAttribute('hidden', 'hidden')
      }
    })
  }

  // Function to update all progress bars
  function updateAllProgressBars(cartTotal, itemCount) {
    // Toggle visibility based on item count
    if (itemCount !== undefined) {
      toggleProgressBarVisibility(itemCount)
    }

    const progressBars = document.querySelectorAll('free-ship-progress-bar')
    progressBars.forEach(function(bar) {
      // Skip hidden bars
      if (bar.style.display === 'none' || bar.hasAttribute('hidden')) {
        return
      }

      const progressElement = bar.querySelector('.progress')
      if (!progressElement) return

      // Check if this is a product page progress bar
      const isProductPage = bar.hasAttribute('data-product-page')

      if (isProductPage) {
        // For product page, get current variant price
        // Try to get variant price from the progress element first
        let variantPrice = parseInt(progressElement.getAttribute('data-variant-price')) || 0

        // If not set or 0, try to get from product form
        if (variantPrice === 0) {
          variantPrice = getCurrentVariantPrice()
        }

        // const totalWithVariant = cartTotal + variantPrice
        const totalWithVariant = cartTotal

        progressElement.setAttribute('data-total-order', totalWithVariant)
        progressElement.setAttribute('data-cart-total', cartTotal)

        if (variantPrice > 0) {
          progressElement.setAttribute('data-variant-price', variantPrice)
        }
      } else {
        // For cart drawer/page, use cart total directly
        progressElement.setAttribute('data-total-order', cartTotal)
      }

      // Update this specific progress bar
      const progressBar = new FSProgressBar()
      progressBar.elements = [bar]
      progressBar.updateProgressBar(bar)
    })
  }

  // Function to fetch cart and update progress bars
  function fetchCartAndUpdate() {
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart.js'

    if (window.fetch) {
      fetch(cartUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('Cart fetch failed')
          }
          return response.json()
        })
        .then(cart => {
          const cartTotal = cart.total_price || 0
          const itemCount = cart.item_count || 0
          updateAllProgressBars(cartTotal, itemCount)
        })
        .catch(error => {
          console.error('Error fetching cart:', error)
          // Fallback: try to sync from cart drawer
          syncCartDrawerToProductPage()
        })
    } else {
      // Fallback: try to sync from cart drawer
      syncCartDrawerToProductPage()
    }
  }

  // Listen for custom cart update events
  document.addEventListener('cart:promotion:update', function() {
    // Sync from cart drawer first
    syncCartDrawerToProductPage()
    // Also fetch cart to ensure accuracy
    fetchCartAndUpdate()
  })

  // Listen for AJAX cart updates (for themes using AJAX cart)
  if (window.Shopify && window.Shopify.theme) {
    document.addEventListener('ajaxCart:updated', function() {
      setTimeout(function() {
        // Sync from cart drawer first
        syncCartDrawerToProductPage()
        // Also fetch cart to ensure accuracy
        fetchCartAndUpdate()
      }, 100)
    })
  }

  // Listen for ajaxProduct:added event (when product is added to cart)
  document.addEventListener('ajaxProduct:added', function(event) {
    setTimeout(function() {
      // Sync from cart drawer first
      syncCartDrawerToProductPage()
      // Also fetch cart to ensure accuracy
      fetchCartAndUpdate()
    }, 200)
  })


  // Function to update product page progress bars with variant price
  function updateProductPageProgressBars(variantPrice, cartTotal, variant) {
    const productPageBars = document.querySelectorAll('free-ship-progress-bar[data-product-page]')
    productPageBars.forEach(function(bar) {
      const progressElement = bar.querySelector('.progress')
      if (progressElement) {
        // Use provided cartTotal or fetch from server
        let currentCartTotal = cartTotal
        if (currentCartTotal === undefined) {
          currentCartTotal = parseInt(progressElement.getAttribute('data-cart-total')) || 0
          // If cart total is 0 or not set, try to fetch it
          if (currentCartTotal === 0) {
            fetchCartAndUpdate()
            return
          }
        }

        // If variantPrice is not provided, try to get it
        let currentVariantPrice = variantPrice
        if (currentVariantPrice === undefined || currentVariantPrice === 0) {
          currentVariantPrice = parseInt(progressElement.getAttribute('data-variant-price')) || getCurrentVariantPrice()
        }

        const totalWithVariant = currentCartTotal + (currentVariantPrice || 0)
        progressElement.setAttribute('data-total-order', totalWithVariant)
        progressElement.setAttribute('data-variant-price', currentVariantPrice || 0)
        if (cartTotal !== undefined) {
          progressElement.setAttribute('data-cart-total', cartTotal)
        }

        const progressBar = new FSProgressBar()
        progressBar.elements = [bar]
        progressBar.updateProgressBar(bar)
      }
    })
  }
  document.addEventListener('variant:change', function(event) {
    const variant = event.detail.variant
    console.log("变体切换", variant)
    console.log("变体 available:", variant ? variant.available : "未找到变体")

    // 如果是产品页面，更新变体底部文本
    if (variant) {
      updateVariantBottomText(variant.id)
    }
  })

  // 更新变体底部文本的函数
  function updateVariantBottomText(variantId) {
    const progressBars = document.querySelectorAll('free-ship-progress-bar[data-product-page]')
    
    progressBars.forEach(function(bar) {
      const bottomTextContainer = bar.querySelector('[data-variant-bottom-text-container]')
      if (!bottomTextContainer) return

      // 获取变体 metafields 数据
      const metafieldsScript = bar.querySelector('[data-variant-metafields-json]')
      if (!metafieldsScript) return

      try {
        const metafieldsData = JSON.parse(metafieldsScript.textContent)
        const variantData = metafieldsData.variants.find(function(v) {
          return v.id && v.id.toString() === variantId.toString()
        })

        if (variantData && variantData.free_shipping_bottom_text) {
          bottomTextContainer.textContent = variantData.free_shipping_bottom_text
        } else {
          bottomTextContainer.textContent = ""
        }
      } catch (e) {
        console.warn("Failed to parse variant metafields data:", e)
      }
    })
  }

  // Update progress bar when cart drawer is opened or updated
  function initCartDrawerListeners() {
    const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('main-cart')
    if (cartDrawer) {
      // Sync cart drawer to product page on initialization
      setTimeout(function() {
        syncCartDrawerToProductPage()
      }, 200)

      // Listen for drawer open
      cartDrawer.addEventListener('cart:drawer:opened', function() {
        setTimeout(function() {
          new FSProgressBar()
          // Sync to product page
          syncCartDrawerToProductPage()
        }, 100)
      })

      // Listen for cart drawer content updates
      cartDrawer.addEventListener('cart:drawer:updated', function() {
        setTimeout(function() {
          syncCartDrawerToProductPage()
        }, 150)
      })

      // Listen for cart contents update
      const observer = new MutationObserver(function(mutations) {
        let shouldUpdate = false
        let cartDrawerCartTotal = null

        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length || mutation.removedNodes.length) {
            shouldUpdate = true
          }
          // Check if progress bar attributes changed in cart drawer
          if (mutation.type === 'attributes' && mutation.target.classList.contains('progress')) {
            shouldUpdate = true
            // Get cart total from cart drawer progress bar
            const drawerProgress = cartDrawer.querySelector('.free-shipping-bar .progress')
            if (drawerProgress) {
              cartDrawerCartTotal = parseInt(drawerProgress.getAttribute('data-total-order')) || null
            }
          }
        })

        if (shouldUpdate) {
          setTimeout(function() {
            // Get cart total from cart drawer progress bar if available
            const drawerProgressBar = cartDrawer.querySelector('free-ship-progress-bar')
            let cartTotal = cartDrawerCartTotal

            if (!cartTotal && drawerProgressBar) {
              const drawerProgress = drawerProgressBar.querySelector('.progress')
              if (drawerProgress) {
                cartTotal = parseInt(drawerProgress.getAttribute('data-total-order')) || null
              }
            }

            // If we have cart total from drawer, sync to product page progress bars
            if (cartTotal !== null && cartTotal !== undefined) {
              // Get item count
              const itemCount = getCartItemCount()
              // Sync cart drawer progress to product page
              updateAllProgressBars(cartTotal, itemCount)
            } else {
              // Try to sync from cart drawer
              syncCartDrawerToProductPage()
              // Fallback: update all progress bars
              const progressBars = document.querySelectorAll('free-ship-progress-bar')
              progressBars.forEach(function(bar) {
                const progressElement = bar.querySelector('.progress')
                if (progressElement) {
                  const currentTotal = progressElement.getAttribute('data-total-order')
                  if (currentTotal) {
                    const progressBar = new FSProgressBar()
                    progressBar.elements = [bar]
                    progressBar.updateProgressBar(bar)
                  }
                }
              })
            }
          }, 100)
        }
      })

      const cartContent = cartDrawer.querySelector('.drawer__scrollable') || cartDrawer.querySelector('.cart__items')
      const freeShippingBar = cartDrawer.querySelector('.free-shipping-bar')
      if (cartContent) {
        observer.observe(cartContent, {
          childList: true,
          subtree: true
        })
      }
      if (freeShippingBar) {
        observer.observe(freeShippingBar, {
          attributes: true,
          attributeFilter: ['data-total-order'],
          subtree: true,
          childList: true
        })
      }

      // Also observe the progress element directly
      const drawerProgress = freeShippingBar ? freeShippingBar.querySelector('.progress') : null
      if (drawerProgress) {
        observer.observe(drawerProgress, {
          attributes: true,
          attributeFilter: ['data-total-order']
        })
      }
    }
  }

  // Initialize cart drawer listeners when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerListeners)
  } else {
    initCartDrawerListeners()
  }

  // Re-initialize when sections are loaded (for AJAX cart updates)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail && event.detail.sectionId) {
      setTimeout(function() {
        new FSProgressBar()
      }, 100)
    }
  })

  // Listen for section updates (when cart sections are re-rendered)
  document.addEventListener('shopify:section:reorder', function(event) {
    setTimeout(function() {
      new FSProgressBar()
    }, 100)
  })

  // Monitor for dynamically added progress bars (when cart drawer content is updated)
  function observeProgressBars() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check if the added node is a progress bar or contains one
            if (node.tagName === 'FREE-SHIP-PROGRESS-BAR' || node.querySelector('free-ship-progress-bar')) {
              setTimeout(function() {
                new FSProgressBar()
              }, 50)
            }
            // Also check for progress elements being updated
            const progressElements = node.querySelectorAll ? node.querySelectorAll('.progress[data-total-order]') : []
            if (progressElements.length > 0) {
              setTimeout(function() {
                // Check if this is from cart drawer
                const cartDrawer = document.querySelector('cart-drawer')
                let cartTotal = null

                if (cartDrawer) {
                  const drawerProgress = cartDrawer.querySelector('.free-shipping-bar .progress')
                  if (drawerProgress) {
                    cartTotal = parseInt(drawerProgress.getAttribute('data-total-order'))
                  }
                }

                if (cartTotal !== null && cartTotal !== undefined) {
                  // Get item count
                  const itemCount = getCartItemCount()
                  // Sync from cart drawer to product page
                  updateAllProgressBars(cartTotal, itemCount)
                } else {
                  // Fallback: update all progress bars
                  const progressBars = document.querySelectorAll('free-ship-progress-bar')
                  progressBars.forEach(function(bar) {
                    const progressBar = new FSProgressBar()
                    progressBar.elements = [bar]
                    progressBar.updateProgressBar(bar)
                  })
                }
              }, 50)
            }
          }
        })

        // Also check for attribute changes on progress elements
        if (mutation.type === 'attributes' && mutation.target.classList.contains('progress')) {
          const progressElement = mutation.target
          const cartTotal = parseInt(progressElement.getAttribute('data-total-order'))

          // If this progress bar is in cart drawer, sync to product page
          const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('main-cart')
          if (cartDrawer && cartDrawer.contains(progressElement)) {
            setTimeout(function() {
              // Get item count
              const itemCount = getCartItemCount()
              // Sync cart drawer progress to product page
              updateAllProgressBars(cartTotal, itemCount)
            }, 50)
          }
        }
      })
    })

    // Observe the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-total-order']
    })
  }

  // Initialize observer when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeProgressBars)
  } else {
    observeProgressBars()
  }

})()
